import { render, staticRenderFns } from "./ExchangeRow.vue?vue&type=template&id=0998c368&scoped=true"
import script from "./ExchangeRow.vue?vue&type=script&lang=js"
export * from "./ExchangeRow.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRow.vue?vue&type=style&index=0&id=0998c368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0998c368",
  null
  
)

export default component.exports